<div class="layout-hbox" style="align-items: stretch;">
    <div class="left-text-container">
        <div class="vertical-text">{{matrix().name}}</div>
    </div>
    <wj-flex-grid #grid
                  [autoGenerateColumns]="false" [headersVisibility]="Wijmo.HeadersVisibility.Column"
                  [allowResizing]="Wijmo.AllowResizing.None" [isReadOnly]="true"
                  (initialized)="onGridInitialized(grid)"
    >
    </wj-flex-grid>
</div>
